import { formatDate } from '@frontend/date';

export const formatRange = (range?: string[], format = 'YYYY-MM-DD'): [string, string] => {
  if (!range) return ['', ''];
  return [formatDate(range?.[0], format), formatDate(range?.[1], format)];
};

export const rangeHasDate = (range: string[]) => !!range[0] || !!range[1];
